export default __webpack_public_path__ + "static/media/Mohit Maurya.f6efeeee.pdf";